import { IconBack } from "app/components/Icon/Icon";
import type { RunnerAggregatedPriceType } from "app/types/eventType";
import { ExchangeRunnerPriceSides } from "app/utils/const";
import { useEffect, useRef, useState } from "react";
import "./DisplayExchangeMarketRunnerPriceArrow.scss";
//
function DisplayExchangeMarketRunnerPriceArrow(props: {
  price: RunnerAggregatedPriceType;
}) {
  const [exchangePrice, setExchangePrice] =
    useState<RunnerAggregatedPriceType>();
  const prevPrice: any = usePrevious(exchangePrice);
  const [displayArrow, setDisplayArrow] = useState(false);

  useEffect(() => {
    return setExchangePrice(props.price);
  }, []);

  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }

  useEffect(() => {
    if (props.price !== exchangePrice) {
      if (props.price.decimalOdds !== exchangePrice?.decimalOdds) {
        setExchangePrice(props.price);
      }
    }
  }, [props.price]);

  useEffect(() => {
    if (
      prevPrice &&
      prevPrice.decimalOdds !== undefined &&
      exchangePrice !== undefined
    ) {
      if (prevPrice.decimalOdds !== exchangePrice.decimalOdds) {
        if (prevPrice.decimalOdds < exchangePrice.decimalOdds) {
          setExchangePrice({
            ...exchangePrice,
            direction: ExchangeRunnerPriceSides.UP,
          });
          setDisplayArrow(true);
        } else if (prevPrice.decimalOdds > exchangePrice.decimalOdds) {
          setExchangePrice({
            ...exchangePrice,
            direction: ExchangeRunnerPriceSides.DOWN,
          });
          setDisplayArrow(true);
        } else {
          setExchangePrice({ ...exchangePrice, direction: "" });
          setDisplayArrow(false);
        }
      }
    }
  }, [exchangePrice]);

  useEffect(() => {
    if (displayArrow) {
      setTimeout(() => {
        setDisplayArrow(false);
      }, 1500);
    }
  }, [displayArrow]);

  return (
    <span
      className={`exchange__runner-prices-arrow ${
        exchangePrice?.direction || ""
      }`}
    >
      {displayArrow &&
        (exchangePrice?.direction === ExchangeRunnerPriceSides.DOWN ? (
          <IconBack />
        ) : null)}
      {displayArrow &&
        (exchangePrice?.direction === ExchangeRunnerPriceSides.UP ? (
          <IconBack />
        ) : null)}
    </span>
  );
}

export default DisplayExchangeMarketRunnerPriceArrow;
